const features = [
  {
    title: 'Faster Product Discovery',
    description: 'Stop wasting hours scrolling through endless listings. Our organized spreadsheet approach lets you pinpoint exactly what you need in seconds, with verified QC data and structured category navigation that makes product research effortless.',
    icon: 'ri-search-eye-line',
    stats: '2x',
    statsLabel: 'Research Speed',
  },
  {
    title: 'Better Organization',
    description: 'Manage your entire product research workflow from one centralized hub. Our spreadsheet-based system categorizes thousands of items by type, quality rating, price range, and popularity, giving you a bird\'s-eye view of the entire marketplace.',
    icon: 'ri-folder-chart-line',
    stats: '14',
    statsLabel: 'Categories Covered',
  },
  {
    title: 'Smart Comparisons',
    description: 'Compare products side by side with our structured data format. Evaluate pricing, sizing, material quality, and seller ratings at a glance. Make informed decisions based on real data rather than guesswork or scattered reviews.',
    icon: 'ri-scales-3-line',
    stats: '98%',
    statsLabel: 'Accuracy Rate',
  },
  {
    title: 'Beginner Friendly',
    description: 'New to spreadsheet-based shopping? No problem. Our step-by-step guides walk you through everything from reading spreadsheet data to finding hidden gems. Built with newcomers in mind, so you can start discovering great products in minutes.',
    icon: 'ri-user-smile-line',
    stats: '10K+',
    statsLabel: 'Happy Users',
  },
];

export { features };